import React, {useState, useEffect} from 'react'
import axios from 'axios'
import {useParams} from 'react-router-dom'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export function VerifyAccountPage1(){
    const [msg, setMsg] = useState('')
    const [data, setData] = useState('')
    const [otcBtn, setOtcBtn] = useState(false)
    const onChangeInput = ({ currentTarget: input }) => { setData({ ...data, [input.name]: input.value }) }
    const onClick2Verify =async() =>{
        setOtcBtn(true)
        setMsg('Please wait for 5 seconds...')
        const { data: res } = await axios.post(`${APIURL}/account-confirmation1`,data)
        setMsg(res.msg)
        setTimeout(() => {
            return window.location.replace('/login')
        }, 3000)
    }
    return(
        <div className='mt-4 m-auto structure__verifyaccount__container'>
        <h2 className='mb-4 text-lg structure__main__subttl'>Verification Page</h2>
        {/* This url is expired or url is wrong. Please check it again. */}
        <div className='m-auto flex flex-col w-fit justify-center'>
        <input name='confirmed' placeholder='verification code' className='border-[1px] border-gray-800 structure__login__input w-full md:w-96 bitter mb-[4px]' onChange={onChangeInput}/>
        <button className='hover:bg-[#365c88] disabled:bg-[#dcdcdc] disabled:border disabled:border-gray-200 bg-[#414c75] h-[28px] text-[13px] pl-[12px] pr-[12px] text-white m-auto font-medium bitter' onClick={onClick2Verify} disabled={otcBtn}>Confirm your account</button>
        </div>
        <div className='m-auto text-center mb-4 bitter'>
        {msg}
        </div>
        </div>
    )
}
export function VerifyAccountPage2(){
    const [msg, setMsg] = useState('')
    const [checkConfirmationNum, setcheckConfirmationNum] = useState(false)
    const [otcBtn, setOtcBtn] = useState(false)
    let params = useParams()
    useEffect(() => {
        if(!checkConfirmationNum){checkNumber()}
    })
    const checkNumber = async () => {
        try {
            const { data: res } = await axios.post(`${APIURL}/check-confirmation-number1`,{'confirmed':params.verificationcode})
            console.log(res.res)
            if(res.res==false){
                return window.location.replace('/404')
            }
            setcheckConfirmationNum(true)            
            return
        } catch (err) {
          console.error(err);
        }
    }
    const onClick2Verify =async() =>{
        setOtcBtn(true)
        setMsg('Please wait for 5 seconds...')
        const { data: res } = await axios.post(`${APIURL}/account-confirmation1`,{'confirmed':params.verificationcode})
        setMsg(res.msg)
        setTimeout(() => {
            return window.location.replace('/login')
        }, 3000)
    }
    return(
        <div className='mt-4 m-auto structure__verifyaccount__container'>
        <h2 className='mb-4 text-lg structure__main__subttl'>Verification Page</h2>
        <div className='mt-1 flex w-full text-center bitter'><button className='m-auto mb-2' onClick={onClick2Verify} disabled={otcBtn}>Confirm your account</button></div>
        <div className='m-auto text-center mb-4'>
        {msg}
        </div>
        </div>
    )
}